// Design tokens — Formulários (listagem + builder).
// Referência: DESIGN_NOT_GENERIC.md (header Contatos)

export const FORMULARIOS_DESIGN = {
  // ---------- shell ----------
  root: 'flex flex-col h-full min-h-0 w-full overflow-y-auto bg-[#f4f4f7] text-[#18181b]',
  rootFill: 'flex flex-col h-full w-full bg-[#f4f4f7] text-[#18181b] overflow-hidden',
  fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
  container: 'w-full px-4 md:px-6 lg:px-8',
  pageBody: 'pt-4 pb-6',

  // ---------- barra de topo (padrão Contatos / DESIGN_NOT_GENERIC) ----------
  stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec] shrink-0',
  headerRow: 'flex flex-wrap items-center gap-2.5 py-3',
  title: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b] shrink-0 mr-1.5',
  topbarActions: 'flex items-center gap-2.5 flex-shrink-0',
  searchRow: 'flex items-center w-full sm:w-[240px] ml-auto min-w-0',
  searchField:
    'flex items-center gap-2.5 w-full h-10 px-3.5 rounded-lg border border-[#d4d4d8] bg-white transition-colors hover:border-[#b8b8c0] focus-within:border-[#8b5cf6] focus-within:ring-2 focus-within:ring-[#c4b5fd]',
  searchIconBtn: 'flex-shrink-0 text-[#a1a1aa] hover:text-[#6d28d9] transition-colors',
  searchInput:
    'flex-1 min-w-0 h-auto border-0 bg-transparent p-0 text-[14px] md:text-[14px] text-[#18181b] shadow-none outline-none ring-0 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 placeholder:text-[#a1a1aa]',
  body: 'flex-1 min-h-0 flex flex-col px-4 md:px-6 lg:px-8 pt-4 pb-6',

  // aliases legados (builder / seções internas)
  topbar: 'flex flex-col md:flex-row md:items-center justify-between gap-4 py-[18px]',
  topbarIdentity: 'flex items-start gap-3.5 min-w-0 flex-1',
  iconTile:
    'flex items-center justify-center flex-shrink-0 w-[42px] h-[42px] rounded-[10px] bg-[#ede9fe] text-[#6d28d9]',
  subtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5] max-w-2xl',

  // ---------- builder header ----------
  builderHeader: 'shrink-0 bg-white border-b border-[#e7e7ec]',
  builderTopbar: 'flex flex-wrap items-center gap-2.5 px-4 md:px-6 lg:px-8 py-3',
  backButton:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#71717a] transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b] flex-shrink-0',
  builderTitleInput:
    'bg-transparent border-none outline-none focus:ring-0 text-[18px] font-bold tracking-[-0.02em] text-[#18181b] min-w-0 w-full max-w-[240px] truncate placeholder:text-[#a1a1aa]',
  builderDivider: 'h-5 w-px bg-[#e7e7ec] mx-1 flex-shrink-0 hidden md:block',
  publicLinkBar:
    'flex items-center gap-2 px-4 md:px-6 lg:px-8 py-2 bg-[#fafafb] border-t border-[#f0f0f3]',
  publicLinkLabel: 'text-[12px] font-medium text-[#71717a] whitespace-nowrap',
  publicLinkCode: 'text-[12px] text-[#71717a] font-mono truncate',

  // ---------- aba respostas (padrão Contatos) ----------
  respostasRoot: 'flex-1 min-h-0 flex flex-col bg-[#f4f4f7] overflow-hidden',
  respostasHeader: 'shrink-0 bg-white border-b border-[#e7e7ec]',
  respostasBody: 'flex-1 min-h-0 flex flex-col lg:flex-row gap-3.5 px-4 md:px-6 lg:px-8 pt-4 pb-6 overflow-hidden',
  respostasSidebar: 'w-full lg:w-[240px] flex-shrink-0 flex flex-col gap-2',
  respostasMain: 'flex-1 min-w-0 flex flex-col min-h-0',
  respostasToolbar: 'flex flex-wrap items-center gap-2.5 mb-3.5',
  respostasPanel:
    'bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden min-w-0 flex-1 min-h-0 flex flex-col',
  metricRow:
    'flex items-baseline justify-between gap-3 px-3.5 py-2.5 bg-white border border-[#e7e7ec] rounded-lg',
  metricValue: 'text-[18px] font-bold tracking-[-0.02em] text-[#18181b] tabular-nums',
  metricLabel: 'text-[12px] text-[#71717a]',
  chartCard: 'bg-white border border-[#e7e7ec] rounded-lg p-3.5',
  chartTitle: 'text-[13px] font-semibold text-[#18181b] mb-3',
  filterSelect:
    'h-10 w-full sm:w-[160px] rounded-lg border border-[#d4d4d8] bg-white text-[13px] text-[#18181b] shadow-none',
  iconButtonActive:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#a78bfa] bg-[#ede9fe] text-[#5b21b6]',
  viewToggle: 'inline-flex items-center gap-1',

  // ---------- abas ----------
  tabsList:
    'flex h-auto items-center justify-start gap-[26px] rounded-none bg-transparent p-0 overflow-x-auto overflow-y-hidden [scrollbar-width:none] [&::-webkit-scrollbar]:hidden',
  tab:
    'flex-shrink-0 rounded-none bg-transparent px-0.5 py-0 pt-2.5 pb-3 text-[14px] font-medium text-[#71717a] whitespace-nowrap transition-colors hover:text-[#18181b]',
  tabActive: 'text-[#6d28d9] font-semibold shadow-[inset_0_-2px_0_#6d28d9]',
  tabsMobile:
    'flex md:hidden border-t border-[#f0f0f3]',
  tabMobile:
    'flex-1 flex items-center justify-center gap-1.5 py-2.5 text-[13px] font-medium text-[#a1a1aa] transition-colors',
  tabMobileActive: 'text-[#6d28d9] font-semibold shadow-[inset_0_-2px_0_#6d28d9]',

  // ---------- cabeçalho de seção ----------
  sectionHeader: 'mt-[18px] first:mt-0 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3',
  sectionHeaderMain: 'min-w-0',
  sectionHeaderTitle: 'text-[13px] font-bold uppercase tracking-[0.06em] text-[#a1a1aa]',
  sectionHeaderSub: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5]',

  // ---------- filtros ----------
  filtersRow: 'flex flex-col sm:flex-row sm:items-center gap-2.5 mt-4 mb-5',
  searchWrap: 'relative flex-1 min-w-0',
  searchIcon: 'absolute left-3.5 top-1/2 -translate-y-1/2 text-[#a1a1aa] pointer-events-none',
  search:
    'w-full h-10 box-border pl-10 pr-3.5 rounded-lg border border-[#d4d4d8] bg-white text-[14px] text-[#18181b] placeholder:text-[#a1a1aa] shadow-none transition-colors focus:outline-none focus:border-[#8b5cf6] focus:ring-2 focus:ring-[#c4b5fd]',

  // ---------- cartões ----------
  stack: 'flex flex-col gap-3.5',
  card: 'bg-white border border-[#e7e7ec] rounded-[12px] p-[26px] overflow-hidden min-w-0',
  cardFlush: 'bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden min-w-0',
  cardRows: 'bg-white border border-[#e7e7ec] rounded-[12px] px-[26px] py-2 overflow-hidden min-w-0',
  cardCompact: 'bg-white border border-[#e7e7ec] rounded-[12px] p-[18px] overflow-hidden min-w-0',
  cardTitle: 'text-[15px] font-semibold text-[#18181b]',
  cardSubtitle: 'mt-0.5 text-[13px] text-[#71717a] leading-[1.5]',
  divider: 'h-px bg-[#f0f0f3]',

  // ---------- editor cards ----------
  editorCanvas: 'flex-1 overflow-y-auto bg-[#f4f4f7]',
  editorInner: 'w-full max-w-3xl mx-auto py-8 px-4 space-y-3.5',
  editorCard:
    'bg-white border border-[#e7e7ec] rounded-[12px] overflow-hidden min-w-0 transition-colors cursor-pointer',
  editorCardActive: 'border-[#a78bfa] ring-1 ring-[#ddd6fe]',
  editorCardAccent: 'h-2.5 bg-gradient-to-r from-[#8b5cf6] to-[#7c3aed]',
  editorAddButton:
    'inline-flex items-center justify-center gap-2 px-5 py-[9px] rounded-lg border border-dashed border-[#d4d4d8] bg-white text-[13px] font-semibold text-[#71717a] transition-colors hover:border-[#a78bfa] hover:text-[#6d28d9] hover:bg-[#ede9fe]/40',

  // ---------- formulário ----------
  grid2: 'grid grid-cols-1 md:grid-cols-2 gap-6',
  field: 'min-w-0',
  label: 'block text-[13px] font-semibold text-[#18181b] mb-[7px]',
  hint: 'mt-[7px] text-[12px] text-[#a1a1aa] leading-[1.5]',
  input:
    'w-full box-border h-auto px-3.5 py-[11px] rounded-lg border border-[#d4d4d8] bg-white text-[14px] text-[#18181b] shadow-none transition-colors placeholder:text-[#a1a1aa] hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus-visible:border-[#8b5cf6] focus-visible:ring-2 focus-visible:ring-[#c4b5fd] focus-visible:ring-offset-0',
  select:
    'w-full box-border h-auto min-h-[44px] px-3.5 py-[11px] rounded-lg border border-[#d4d4d8] bg-white text-[14px] font-normal text-[#18181b] shadow-none transition-colors hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus:ring-2 focus:ring-[#c4b5fd]',

  // ---------- toggle ----------
  toggleRow: 'flex items-center gap-4 py-[18px]',
  toggleRowDivided: 'border-b border-[#f0f0f3]',
  toggleRowMain: 'flex-1 min-w-0',
  toggleRowLabel: 'text-[14px] font-semibold text-[#18181b]',
  toggleRowHelp: 'mt-[3px] text-[13px] text-[#71717a] leading-[1.5] max-w-[620px]',
  switch: 'flex-shrink-0 data-[state=checked]:bg-[#6d28d9] data-[state=unchecked]:bg-[#d4d4d8]',

  // ---------- cartões de escolha ----------
  choiceGrid: 'grid grid-cols-1 md:grid-cols-2 gap-2.5',
  choiceCard: 'text-left px-3.5 py-[13px] rounded-lg border transition-colors cursor-pointer',
  choiceCardOn: 'bg-[#ede9fe] border-[#a78bfa]',
  choiceCardOff: 'bg-white border-[#e7e7ec] hover:border-[#d4d4d8]',
  choiceTitle: 'text-[13.5px] font-semibold',
  choiceTitleOn: 'text-[#5b21b6]',
  choiceTitleOff: 'text-[#18181b]',
  choiceHelp: 'mt-[3px] text-[12px] text-[#71717a] leading-[1.45]',

  // ---------- botões ----------
  primaryButton:
    'inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-[10px] bg-gradient-to-b from-[#8b5cf6] to-[#7c3aed] text-white text-[14px] font-semibold whitespace-nowrap shadow-[0_2px_8px_rgba(124,58,237,.32)] transition-colors hover:from-[#7c3aed] hover:to-[#6d28d9] disabled:from-[#e4e4e7] disabled:to-[#e4e4e7] disabled:text-[#a1a1aa] disabled:shadow-none disabled:cursor-not-allowed',
  ghostButton:
    'inline-flex items-center justify-center gap-2 px-4 py-[9px] rounded-lg border border-[#e7e7ec] bg-white text-[13px] font-semibold text-[#52525b] whitespace-nowrap transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b] disabled:opacity-50 disabled:cursor-not-allowed',
  dangerButton:
    'inline-flex items-center justify-center gap-2 px-4 py-[9px] rounded-lg border border-[#e7e7ec] bg-white text-[13px] font-semibold text-[#b42318] whitespace-nowrap transition-colors hover:bg-[#fef3f2] hover:border-[#fecdca] disabled:opacity-50 disabled:cursor-not-allowed',
  iconButton:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#71717a] transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b]',
  iconButtonDanger:
    'inline-flex items-center justify-center w-8 h-8 rounded-lg border border-[#e7e7ec] bg-white text-[#b42318] transition-colors hover:bg-[#fef3f2] hover:border-[#fecdca]',
  link: 'text-[13px] font-semibold text-[#6d28d9] transition-colors hover:text-[#5b21b6] hover:underline',

  // ---------- badges ----------
  badge: 'inline-flex items-center gap-1.5 px-2.5 py-[3px] rounded-md text-[12px] font-semibold whitespace-nowrap flex-shrink-0 border',
  badgeOk: 'bg-[#ecfdf3] text-[#067647] border-[#abefc6]',
  badgeWarn: 'bg-[#fffaeb] text-[#b54708] border-[#fedf89]',
  badgeNeutral: 'bg-[#f4f4f5] text-[#71717a] border-[#e7e7ec]',
  badgeSoft: 'bg-[#ede9fe] text-[#5b21b6] border-[#ddd6fe]',
  badgeDot: 'w-1.5 h-1.5 rounded-full',
  badgeDotOk: 'bg-[#17b26a]',
  badgeDotWarn: 'bg-[#f79009]',
  badgeDotNeutral: 'bg-[#d4d4d8]',

  // ---------- tabela ----------
  tableWrap: 'w-full overflow-x-auto min-w-0',
  tableHead: 'text-[12px] font-semibold uppercase tracking-[0.04em] text-[#a1a1aa]',
  tableCell: 'text-[14px] text-[#18181b]',
  tableCellMuted: 'text-[13px] text-[#71717a]',
  tableRow: 'border-b border-[#f0f0f3] last:border-b-0 hover:bg-[#fafafb] transition-colors',
  tableFooter: 'text-center text-[12px] text-[#a1a1aa] py-3 border-t border-[#f0f0f3]',

  // ---------- stats (legado — preferir metricRow na aba respostas) ----------
  statsStack: 'flex flex-col gap-2',
  statCard: 'bg-white border border-[#e7e7ec] rounded-lg px-3.5 py-2.5 overflow-hidden min-w-0 flex items-baseline justify-between gap-3',
  statIcon: 'hidden',
  statValue: 'text-[18px] font-bold tracking-[-0.02em] text-[#18181b] tabular-nums leading-tight',
  statLabel: 'text-[12px] text-[#71717a]',

  // ---------- empty / loading ----------
  emptyState: 'flex flex-col items-center justify-center flex-1 py-16 text-center px-4',
  emptyIcon:
    'mb-4 flex items-center justify-center w-14 h-14 rounded-[12px] bg-[#f4f4f5] text-[#a1a1aa]',
  emptyTitle: 'text-[15px] font-semibold text-[#18181b]',
  emptyDesc: 'mt-1.5 text-[13px] text-[#71717a] leading-[1.5] max-w-sm mx-auto',
  loadingWrap: 'flex flex-col items-center justify-center py-16 text-[#a1a1aa]',
  loadingIcon: 'w-8 h-8 animate-spin mb-4 text-[#6d28d9]',

  // ---------- dialog ----------
  dialogTitle: 'text-[15px] font-semibold text-[#18181b]',
  dialogDesc: 'text-[13px] text-[#71717a] leading-[1.5]',
  dialogFooter: 'flex justify-end gap-2.5',

  // ---------- view toggle ----------
  viewToggleWrap: 'h-9 inline-flex items-center gap-0.5 bg-[#f4f4f5] p-1 rounded-lg',
  viewToggleBtn:
    'h-7 px-3 rounded-md text-[12.5px] font-semibold text-[#71717a] transition-colors data-[state=active]:bg-white data-[state=active]:text-[#18181b] data-[state=active]:shadow-sm',

  // ---------- save hint ----------
  saveHint: 'text-[13px] text-[#71717a]',
  saveDot: 'inline-block w-1.5 h-1.5 rounded-full bg-[#f79009]',
};

export default FORMULARIOS_DESIGN;
